export function validUsername(str) {
    console.log(str)
    return 1
    // const valid_map = ['admin', 'test','cuiwenchang']
    // return valid_map.indexOf(str.trim()) >= 0
}  

